export default __webpack_public_path__ + "static/media/65.baa4e286.jpg";